import { render, staticRenderFns } from "./LoginOrder.vue?vue&type=template&id=5b61beb4&"
import script from "./LoginOrder.vue?vue&type=script&lang=js&"
export * from "./LoginOrder.vue?vue&type=script&lang=js&"
import style0 from "./LoginOrder.vue?vue&type=style&index=0&id=5b61beb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports